<template>
  <v-container id="dashboard" fluid grid-list-lg class="mx-0 pa-0">
<div><b><u>Statistics</u></b></div>
    <v-layout row wrap>

          <v-container fluid grid-list-sm dark>
            <v-layout class="mt-0 mb-0 mx-1" row wrap>
                  <v-flex sm9 xs12>
                    <v-layout class="mt-2 mb-0 pa-0" row wrap>
                  <v-flex d-flex xs15>
                  User Balance: {{credits}}
                  </v-flex>
                  </v-layout>
                    <v-layout class="mt-2 mb-0 pa-0" row wrap>
                      <v-flex d-flex xs15>
                      <div class="silver--text">New Orders: {{orders.new}}</div>
                      <div class="silver--text">Processing Orders: {{orders.processing}}</div>
                      <div class="silver--text">Rejected Orders: {{orders.rejected}}</div>
                      <div class="silver--text">Success Orders: {{orders.replied}}</div>
                      <div class="silver--text">Total Count: {{orders.total}}</div>
                      </v-flex>

                    </v-layout>
                  </v-flex>
            </v-layout>
          </v-container>
    </v-layout>


  </v-container>
</template>
<script>
  import Doughnut from "../components/chart/Doughnut";
  import api from "@/utils/backend-api";
  import Store from '@/store'

  export default {
    name: "Dashboard",
    data() {
      return {
        orders: [],
        credits: '',
      };
    },
    methods: { },
    components: {
      Doughnut
    },
    created () {

    },
    mounted() {
      api.getData("statistics.php").then(
        res => {
           this.orders = res.data.orders;
           this.credits = res.data.user.credit;
           const user = res.data.user;
           const token = localStorage.token;
           Store.dispatch('user/updateUser', {user, token});
        },
        err => {
          console.log(err);
          if (err.message.includes("403"))
          {
            this.$router.push('/login')
          }
        }
      );
    }

  };
</script>
<style scoped>
  #dashboard .flex {
    margin-bottom: 2px;
  }
</style>



// WEBPACK FOOTER //
// Dashboard.vue?97533fc0